import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mr-2 mb-1 mt-1 d-inline-block"
}

import CoreUiOperatorAvatar from "~/core-ui/vue/chat/CoreUiOperatorAvatar.vue";
import {computed, ref} from "vue";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import getOperatorDisplayName from "~/operatorApplication/ts/service/operators/getOperatorDisplayName";

import OperatorApplicationDialogOpenApiModel = OperatorApplicationApi.OperatorApplicationDialogOpenApiModel;

import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "DialogOperatorsList"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    max: {},
    dialog: {},
    negativeMargin: { default: 1 }
  },
  setup(__props: any) {

let props = __props;

let operators = computed(() => {
    return props.dialog.operatorLogins
        .map(login => OperatorAccountStore.operatorsDictionary.value[login])
        .filter(operator => !!operator);
});

let showAllOperators = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_my_tooltip = _resolveDirective("my-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`mt-n${__props.negativeMargin} mb-n${__props.negativeMargin} d-flex flex-wrap`)
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(operators), (operator, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        (index < __props.max || _unref(showAllOperators))
          ? _withDirectives((_openBlock(), _createBlock(CoreUiOperatorAvatar, {
              key: 0,
              class: "mr-2 mb-1 mt-1",
              size: "2.5em",
              operator: operator
            }, null, 8, ["operator"])), [
              [_directive_my_tooltip, _unref(getOperatorDisplayName)(operator)]
            ])
          : _createCommentVNode("", true)
      ], 64))
    }), 256)),
    (!_unref(showAllOperators) && _unref(operators).length > __props.max)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_el_button, {
            link: "",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(showAllOperators) //@ts-ignore
 ? showAllOperators.value = !_unref(showAllOperators) : showAllOperators = !_unref(showAllOperators))),
            style: {"width":"2.5em","height":"2.5em"},
            class: "d-inline-block"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" +" + _toDisplayString(_unref(operators).length - __props.max), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})